import type { TaskChatAuthorInfo } from '@frontend/api-client';
import { match, P } from '@frontend/duck-tape';
import { Icon, Text, XStack } from '@frontend/web-react';
import { concatClasses, safeCss } from '@frontend/web-utils';

type TaskChatAvatarProps = Pick<TaskChatAuthorInfo, 'initials' | 'type'>;

export const TaskChatAvatar = ({ initials, type }: TaskChatAvatarProps) => {
  const backgroundColorClassName = match(type)
    .with(P.union('client', 'super_agent'), () => safeCss('bg-surfaceBrand'))
    .with(P.union('agent', 'ai_agent'), () => safeCss('bg-textTertiary'))
    .with('ai_bot', () => safeCss('bg-surfaceAccent'))
    .with('automated_message', () => safeCss('bg-surfaceAccent'))
    .otherwise(() => safeCss('bg-textTertiary'));

  return (
    <XStack
      className={concatClasses(
        backgroundColorClassName,
        'rounded-full size-[28px] justify-center items-center',
        type === 'ai_bot' ? 'p-none' : 'p-xs',
      )}
    >
      {match(type)
        .with(P.union('automated_message', 'ai_bot'), () => <Icon name="DuckbillLogo" size="md" />)
        .with(P.union('agent', 'client', 'ai_agent', 'super_agent'), () => (
          <Text
            className="leading-none"
            color={type === 'client' || type === 'super_agent' ? 'accent' : 'inverse'}
            span
            type="captionBold"
          >
            {initials}
          </Text>
        ))
        .otherwise(() => (
          <Text className="leading-none" color="inverse" span type="captionBold">
            {initials}
          </Text>
        ))}
    </XStack>
  );
};
